function renderWishlistButtons() {
    var customerIdElement = document.getElementById('customer-id');
    var wishlistMetafieldElement = document.getElementById('wishlist-metafield');
    var modal = document.getElementById('vanghockPopup');

    if (!customerIdElement || !wishlistMetafieldElement) {
        document.querySelectorAll('.product-header-area').forEach(function(productElement) {
            var buttonHtml = `
                <button aria-label="Add to wishlist" class="wishlist-button" data-inactive="true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                        <g id="wishlist-icon" transform="translate(11618 5590)">
                            <g id="heart" transform="translate(-11831 -5632)">
                                <path id="vanghock-com" d="M15.7,4C18.87,4,21,6.98,21,9.76,21,15.39,12.16,20,12,20S3,15.39,3,9.76C3,6.98,5.13,4,8.3,4A4.772,4.772,0,0,1,12,5.71,4.772,4.772,0,0,1,15.7,4Z" transform="translate(216 46)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                            </g>
                        </g>
                    </svg>
                </button>
            `;
            productElement.innerHTML = buttonHtml;
        });
        return;
    }

    var customerId = customerIdElement.getAttribute('data-customer-id');
    var wishlistMetafield = wishlistMetafieldElement.getAttribute('data-wishlist');
    var wishlistCount = parseInt(wishlistMetafieldElement.getAttribute('data-wishlist-count'), 10);
    var maxWishlistItems = 15;

    var wishlistHandles = wishlistMetafield ? wishlistMetafield.replace(/["[\]]/g, '').split(',') : [];
    wishlistHandles = wishlistHandles.filter(handle => handle !== " empty");

    document.querySelectorAll('.product-header-area').forEach(function(productElement) {
        var productHandle = productElement.getAttribute('data-product-handle');
        var isInWishlist = productElement.hasAttribute('wished');

        var buttonHtml = `
            <button aria-label="${isInWishlist ? 'Remove from wishlist' : 'Add to wishlist'}"
                    class="wishlist-button"
                    data-product-handle="${productHandle}"
                    data-inactive="${wishlistCount >= maxWishlistItems && !isInWishlist ? 'true' : 'false'}">
                <svg xmlns="http://www.w3.org/2000/svg" width= "30" height="30" viewBox="0 0 30 30">
                    <g id="wishlist-icon" transform="translate(11618 5590)">
                        <g id="heart" transform="translate(-11831 -5632)">
                            <path id="vanghock-com" d="M15.7,4C18.87,4,21,6.98,21,9.76,21,15.39,12.16,20,12,20S3,15.39,3,9.76C3,6.98,5.13,4,8.3,4A4.772,4.772,0,0,1,12,5.71,4.772,4.772,0,0,1,15.7,4Z" transform="translate(216 46)" fill="${isInWishlist ? '#000' : 'none'}" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                        </g>
                    </g>
                </svg>
            </button>
        `;

        productElement.innerHTML = buttonHtml;

        var button = productElement.querySelector('.wishlist-button');
        button.addEventListener('click', function(e) {
            e.preventDefault();

            var productHandle = this.getAttribute('data-product-handle');
            var wishlistData = `${customerId}_${productHandle}`;
            if (!wishlistData) return;

            this.disabled = true;
            setTimeout(() => this.disabled = false, 2000);

            var svgPath = this.querySelector('svg path');
            var isFilled = svgPath.getAttribute('fill') === '#000';

            if (!isFilled && wishlistCount >= maxWishlistItems) {
                this.setAttribute('data-inactive', 'true');
                openModal();  // Trigger the popup
                return;
            }

            if (isFilled) {
                wishlistHandles = wishlistHandles.filter(handle => handle !== productHandle);
                wishlistCount--;
            } else {
                wishlistHandles.push(productHandle);
                wishlistCount++;
            }

            var wishlistMetafieldValue = `[${wishlistHandles.join(',')}]`;

            var webhookUrl = isFilled ? 'https://solutions.solvertap.com/webhook/flashrugs-d4f3109b-206e-4f44-84c5-923400ad1385' : 'https://solutions.solvertap.com/webhook/flashrugs-f9eeb82e-b194-4e62-a75d-2692d8e25401';

            fetch(webhookUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    wishlistData: wishlistData,
                }),
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                svgPath.setAttribute('fill', isFilled ? 'none' : '#000');
                var newLabel = isFilled ? 'Add to wishlist' : 'Remove from wishlist';
                this.setAttribute('aria-label', newLabel);

                document.querySelectorAll('.wishlist-button').forEach(function(button) {
                    var handle = button.getAttribute('data-product-handle');
                    var isInactive = wishlistCount >= maxWishlistItems && !wishlistHandles.includes(handle);
                    button.disabled = isInactive;
                    button.setAttribute('data-inactive', isInactive ? 'true' : 'false');
                });
            })
            .catch(error => {
                console.error('Error updating wishlist:', error);
            });
        });
    });

    initializePopup();
}

function initializePopup() {
    var modal = document.getElementById('vanghockPopup');
    var closeButtons = document.querySelectorAll('.v-popup-close-btn');

    var openModal = function() {
        modal.style.display = 'flex';
    };

    var closeModal = function() {
        modal.style.display = 'none';
    };

    document.addEventListener('click', function(event) {
        if (event.target.closest('#new-login') || event.target.closest('.wishlist-button[data-inactive="true"]')) {
            openModal();
        }
    });

    closeButtons.forEach(function(btn) {
        btn.addEventListener('click', closeModal);
    });

    window.onclick = function(event) {
        if (event.target == modal) {
            closeModal();
        }
    };
}

document.addEventListener('DOMContentLoaded', function() {
    renderWishlistButtons();
    initializePopup();
});